import React from 'react';
import DayPicker, { DateUtils } from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import styled from 'styled-components';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, TimePicker } from '@material-ui/pickers';

import { FieldArray } from 'react-final-form-arrays';
import { fechaFuncion, formatFuncion } from '../../utils/hora';

const MONTHS = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
];

const WEEKDAYS_LONG = [
    'Domingo',
    'Lunes',
    'Martes',
    'Miércoles',
    'Jueves',
    'Viernes',
    'Sábado',
];

const WEEKDAYS_SHORT = ['D', 'L', 'M', 'X', 'J', 'V', 'S'];

export default class Fechas extends React.Component {
    constructor(props) {
        super(props);
        this.handleDayClick = this.handleDayClick.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleTimeClick = this.handleTimeClick.bind(this);
        this.cleanDates = this.cleanDates.bind(this);
        this.deleteDates = this.deleteDates.bind(this);
        this.state = {
            selectedDays: [],
            selectedUTC: [],
            selectedTime: new Date(),
        };
    }

    handleDayClick(day, { selected }) {
        const selectedDays = this.state.selectedDays.concat();
        const selectedUTC = this.state.selectedUTC.concat();
        if (selected) {
            const selectedIndex = selectedDays.findIndex(selectedDay =>
                DateUtils.isSameDay(selectedDay, day)
            );
            selectedDays.splice(selectedIndex, 1);
            selectedUTC.splice(selectedIndex, 1);
        } else {
            // Día pulsado + hora del selector, interpretados como hora de Madrid
            // (no la zona del navegador). La API guarda milisegundos UTC.
            const dayUTC = fechaFuncion(day, this.state.selectedTime);
            // Check if date already exists and push
            if (this.props.fechas) {
                if (!this.props.fechas.includes(dayUTC)) selectedUTC.push(dayUTC)
            } else {
                selectedUTC.push(dayUTC)
            }
            // Push into selectedDays too for no funcionality loose
            selectedDays.push(day);
        }
        this.setState({ selectedDays });
        this.setState({ selectedUTC });
    }

    cleanDates() {
        const selectedDays = [];
        this.setState({ selectedDays });
        const selectedUTC = [];
        this.setState({ selectedUTC });
        return;
    }

    deleteDates() {
        this.props.remove()
    }

    handleSubmit() {
        this.state.selectedUTC.length > 0 && this.state.selectedUTC.forEach(utc => {
            this.props.push('fechas', { fecha: utc, compras: 0, reservas: 0 })
        })
        this.cleanDates();
    }

    handleTimeClick(time) {
        this.setState({
            selectedTime: time
        })
    }

    render() {
        return (
            <DatePickerStyled>
                <h3>Fechas</h3><p>Los contadores, portales y aforo por función se gestionan en Entradas y aforo.</p>
                <pre>Seleccionar hora antes de <br />pulsar sobre el calendario<br /></pre>
                <p><strong>Hora de España (Madrid)</strong>, aunque el ordenador esté en otra zona horaria.</p>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <TimePicker
                        value={this.state.selectedTime}
                        onChange={this.handleTimeClick}
                    />
                </MuiPickersUtilsProvider>
                <DayPicker
                    selectedDays={this.state.selectedDays}
                    onDayClick={this.handleDayClick}
                    selector={this.state.selectedDays}
                    months={MONTHS}
                    weekdaysLong={WEEKDAYS_LONG}
                    weekdaysShort={WEEKDAYS_SHORT}
                    firstDayOfWeek={1}
                />
                <div>
                    <span id="btn-image" onClick={this.handleSubmit}>Añadir</span>
                    <span id="btn-image" onClick={this.deleteDates}>Limpiar</span>
                </div>


                <div id="fechas-edit">
                    <span className="fecha-edit">Fecha&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <span className="fecha-num">&nbsp;&nbsp;&nbsp;&nbsp;Compras&nbsp;&nbsp;</span>
                    <span className="fecha-num">Reservas</span>
                </div>


                <FieldArray name="fechas">
                    {({ fields }) => (
                        <div>
                            {fields.map((name, index) => {
                                let date
                                if (fields.value[index].fecha) date = formatFuncion(fields.value[index].fecha);
                                else return null
                                
                                return <div key={index}>
                                    <span>{date || ""}</span>

                                    <span>{fields.value[index].compras || 0}</span>

                                    <span>{fields.value[index].reservas || 0}</span>

                                    <button type="button" onClick={() => fields.remove(index)}>
                                        ❌
                                    </button>
                                </div>
                            })}

                        </div>
                    )}
                </FieldArray>
            </DatePickerStyled>
        );
    }
}
const DatePickerStyled = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    min-width: 100%;


    #fechas-edit{
        margin-top: 1vw;
        font-weight: bold;
    }

    .fecha-edit-h{
        width: 250px;
        font-weight: bold;
    }

    .fecha-num-h{
        width: 50px
        font-weight: bold;
    }
    .DayPicker{
        color: black;
        font-size: 1.5vw;
    }
    .DayPicker-Day--today{
        color: #f46d2b;
        :hover{
            color: #f46d2b;
        }
    }
    DayPicker-Day--selected{
        background-color: #f46d2b;
    }
`
